// src/components/quickMessage/QmAvatar.tsx -- avatar with the Quick Message
// blue-tinted gradient. Per gotcha #9, this gradient is QM-only and never
// shows elsewhere in the app; that's why it isn't an extra tone on the
// shared Avatar.
//
// The orphan-sender path (sender.deleted) renders a muted grey square with
// no initials -- the API's "Former colleague" copy is rendered alongside.

import { F } from "../../theme";
import { QM, senderInitials, type QmSender } from "../../lib/quickMessages";

export interface QmAvatarProps {
  sender: QmSender;
  size?: number;
}

export function QmAvatar({ sender, size = 42 }: QmAvatarProps) {
  if (sender.deleted) {
    return (
      <div
        aria-hidden="true"
        style={{
          width: size,
          height: size,
          borderRadius: size / 3.4,
          background: "#D9D2C5",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.3)",
          flexShrink: 0,
        }}
      />
    );
  }
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size / 3.4,
        background: `linear-gradient(135deg, ${QM.avatarA}, ${QM.avatarB})`,
        color: "#FFFCEC",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: F.serif,
        fontWeight: 700,
        fontSize: size * 0.4,
        boxShadow:
          "inset 0 1px 0 rgba(255,255,255,0.3), 0 1px 2px rgba(42,83,128,0.20)",
        flexShrink: 0,
        letterSpacing: 0,
      }}
    >
      {senderInitials(sender)}
    </div>
  );
}
